import api from './api';

const URLS = {
  listRooms: 'listRooms',
};

export const listRooms = () => {
  return api.post(URLS.listRooms);
};
